import { SaveButton } from 'react-admin'
import { FilterButtonProps } from './type'
import palette from '../../themes/styles/palette'
const FilterButton: React.FC<FilterButtonProps> = ({ label, Icon }) => {
  return (
    <>
      <SaveButton
        style={{ border: `1px solid ${palette['primary'].darker}` }}
        fullWidth
        label={label}
        icon={<Icon />}
      />
    </>
  )
}

export default FilterButton
